import { captureException } from '@atlassian/error-handling';

import type {
	ProvisionStartNormalizeSeatRequest,
	ProvisionStartResponse,
} from '../provisioning-api/types';

const XFLOW_SERVICE_URL = '/gateway/api/xflow/provision/cloud';

export const normalizeSeat = async ({
	cloudId,
	signal,
}: ProvisionStartNormalizeSeatRequest): Promise<ProvisionStartResponse> => {
	try {
		const response = await fetch(
			`${XFLOW_SERVICE_URL}/${encodeURIComponent(cloudId)}/product/teamwork-collection/job/nth-user-access/start`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({}),
				signal,
			},
		);

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return response.json();
	} catch (error) {
		captureException('Failed to start normalize seat job', error as Error, {
			cloudId,
			packageName: '@atlassian/twc-xflow-modal',
			teamName: 'starburst',
		});
		throw error;
	}
};
